export const PageHeadTypes = {
	ROBOTS_NO_INDEX: [{ name: 'robots', content: 'noindex, nofollow' }],
}

export const pageHead = {
	PANEL: {
		PRODUCT_CATALOG: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		PRODUCT_CATALOG_CARS_ID: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		PRODUCT_CATALOG_SEGMENT: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		PARAMETERS: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		PARAMETERS_ID: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		LOYALTY_PROGRAMS: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		DISCOUNT_CODES: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		DISCOUNT_CODES_ID: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
	},
	AUTH: {
		LOGIN: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		REGISTER: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		SIGN_IN: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		ACCOUNT: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		ACCOUNT_DATA: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		ACCOUNT_ORDERS: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		ACCOUNT_ORDER_DETAIL: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		ACCOUNT_PASSWORD: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		ACCOUNT_NOTIFICATIONS: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		ACCOUNT_LANGUAGE: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
	},
	COMMON: {
		ERROR: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
	},
	RESERVATION: {
		RESERVATION: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		RESERVATION_COMPLETED: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
	},
}
